
import React, { useCallback } from 'react';
import Button, { buttonType } from '../../Button';
import styles from './Alert.module.scss';

const Alert = ({ title = "", text = "", button_text = "", content, onButtonClick, onClose, double_button_text = "", onDoubleButtonClick=() => {}, preventCloseOnButton = false }) => {
  const onCloseButtonClickHandle = useCallback(() => {
    if (onButtonClick) {
      onButtonClick();
    }
    if (!preventCloseOnButton && onClose) {
      onClose();
    }
  }, [onButtonClick, onClose, preventCloseOnButton]);

  return <div className={styles.container}>
    {title && <div className={styles.title}>{title}</div>}
    {text && <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />}
    {content && <div className={styles.content}>{content}</div>}
    <div className={styles.buttons}>
      <Button type={buttonType.premium} className={styles.close_button} onClick={onCloseButtonClickHandle} >{button_text}</Button>
      {double_button_text && <Button type={buttonType.secondary} className={styles.close_button} onClick={onDoubleButtonClick} >{double_button_text}</Button>}
    </div>
  </div>;
};

export default Alert;